import { Create, Datagrid, Edit, List, NumberField, NumberInput, ReferenceField, ReferenceInput, required, SelectInput, SimpleForm, TextField, TextInput, EditButton, useRecordContext, AutocompleteInput } from "react-admin";
import { useWatch } from "react-hook-form";

export const DeductionsList = () => (
    <List>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <NumberField source="amount" />
            <TextField source="currency" />
            <TextField source="type" />
            <TextField source="remarks" />
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <EditButton />
        </Datagrid>
    </List>
);

const CompanyTypeInput = props => {
    var company = useWatch({ name: 'parent_company_id' });
    // const values = getValues();
    if (company == null || company === '') {
        company = 99;
    }
    return (
        <ReferenceInput source="company_id" reference="companies" filter={{ parent_company_id: company }}><SelectInput source="name" /></ReferenceInput>
    );
};

const deductionTypeChoices = [
    { id: 'deductions', name: 'Deductions' },
    { id: 'recovery', name: 'Recovery' },
    { id: 'recovery-gst', name: 'Recovery GST' },
];

export const DeductionsCreate = () => (
    <Create>
        <SimpleForm>
            <ReferenceInput source="parent_company_id" reference="parent_companies" validate={required()}><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <CompanyTypeInput />
            <SelectInput source="report_type" choices={[
                { id: 'both', name: 'Both' },
                { id: 'remuneration', name: 'Remuneration' },
                { id: 'reimbursable', name: 'Reimbursable' },
            ]} validate={required()} defaultValue='Both' />
            <SelectInput source="currency" choices={[
                { id: 'INR', name: 'INR' },
                { id: 'USD', name: 'USD' },
                { id: 'JPY', name: 'JPY' },
            ]} />
            <SelectInput source="type" choices={deductionTypeChoices} />
            <NumberInput onWheel={e => e.target.blur()} source="amount" label="Deduction Amount" validate={required()} />
            <NumberInput onWheel={e => e.target.blur()} source="rate" label="Deduction Rate" validate={required()} />
            <TextInput source="remarks" />
        </SimpleForm>
    </Create>
);

export const DeductionsEdit = () => (
    <Edit>
        <SimpleForm>
            GC: <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <br />Company: <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <br />Currency: <TextField source="currency" />
            <br />Type: <TextField source="type" />
            <SelectInput source="report_type" choices={[
                { id: 'both', name: 'Both' },
                { id: 'remuneration', name: 'Remuneration' },
                { id: 'reimbursable', name: 'Reimbursable' },
            ]} validate={required()}/>
            <br />Deductions Amount: <NumberInput onWheel={e => e.target.blur()} source="amount" label="Deduction Amount" validate={required()} />
            <br />Deductions Rate: <NumberInput onWheel={e => e.target.blur()} source="rate" label="Deduction Rate" validate={required()} />
            <br /><TextInput source="remarks" />
        </SimpleForm>
    </Edit>
);

const DeductionsReport = () => {
    const record = useRecordContext();
    return (record.report_month_id != null
        ? <ReferenceField source="report_month_id" reference="report_months"><TextField source="name" /></ReferenceField> 
        : <ReferenceField source="reimbursable_report_id" reference="reimbursable_report"><TextField source="name" /></ReferenceField>
    );
}

const DeductionsCurrency = () => {
    const record = useRecordContext();
    return (record.report_month_id != null
        ? <ReferenceField source="report_month_id" reference="report_months"><TextField source="currency" /></ReferenceField> 
        : <ReferenceField source="reimbursable_report_id" reference="reimbursable_report"><TextField source="currency" /></ReferenceField>
    );
}

const DeductionsHistoryFilter = [
    <ReferenceInput source="company_id" reference="companies" alwaysOn><SelectInput optionText="full_name" /></ReferenceInput>,
    <SelectInput  source="type" choices={deductionTypeChoices} alwaysOn />,
];

export const DeductionsHistoryList = () => (
    <List filters={DeductionsHistoryFilter}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="type" />
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <DeductionsReport  label="Report"/>
            <DeductionsCurrency  label="Currency"/>
            <NumberField source="total_amount" />
            <NumberField source="till_amount" />
            <NumberField source="current_amount" />
            <NumberField source="cumulative_amount" />
            <NumberField source="balance_amount" />
        </Datagrid>
    </List>
);